var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 215.03 88.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.39,11.45c.27,12-10.1,17.92-10,25.73.13,16.44,16.44,13.74,16.3,35.16-.27,12.53-8.08,16.57-18.86,16.57S0,84.87,0,71.67c0-21.82,16.7-19,16.7-35,0-9-3.63-10.77-8.75-11C2,25.46.27,22.77.27,17.92.27,9.83,10.64.13,21.42.13,28.56.13,31.12,4.58,31.39,11.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.24,24C43.24,10.24,48.36.54,68.17.54c22,0,27.88,14.41,27.88,45,0,31.12-7.81,43.38-29.23,43.38C49.31,88.91,41,80.16,41,64.53,41,54,45.26,46.75,53.62,46.75c10.51,0,13.87,8.62,25.32,8.48,6.34,0,12-4.31,12-13.2,0-2.83-1.21-4.17-3.9-4.17C81.1,37.86,74,42,62.1,42,49.58,42,43.24,38.26,43.24,24Zm7.68,7.27c0,4.85,3.91,7.28,13.88,7.28,15.22,0,23.84-3.64,23.84-8.89,0-4.45-5-6.6-18.59-6.6C55.64,23,50.92,25.87,50.92,31.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M155.2,58.33c0,17.92-5.12,30.58-26.81,30.58-22.5,0-27.89-14.28-27.89-44.32,0-31.52,8.22-44.05,29.37-44.05,15.49,0,23,5.79,23,15.63,0,6.73-3.1,11.45-9.43,11.45-8.36,0-12-7.14-23-7-7.28,0-14.15,4.18-14.15,12.93,0,2.43,1.08,3.64,3.64,3.64,5.79,0,12.8-4,24.12-4C148.33,33.14,155.2,38.39,155.2,58.33Zm-10-13.74c0-4.71-4.31-7.27-15.09-7.27-14.42,0-23.71,3.63-23.71,9,0,4.18,5,6.07,19.53,6.07C140.78,52.41,145.23,49.71,145.23,44.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M215,43.92c.41,30.31-5,44.86-27.08,44.86-21.42,0-26.67-14.42-26.67-44.73,0-29.1,5.79-44,26.67-44C209.62,0,215.42,15,215,43.92Zm-5.25-6.6c0-9.84-7.14-14-21.83-14-14,0-21.42,4.17-21.42,14,0,10.24,7.14,14.55,21.56,14.55C202.89,51.87,209.76,47.56,209.76,37.32Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.f035827e80b4ecc9ae68d1a92af1eb03.svg";
export { ForwardRef as ReactComponent };